<template>

<com-item name="players.duration" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Time Together">

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data.duration" :subtext="item.plays + ' timed play' + ((item.plays > 1) ? 's' : '')" count-text="hour" :key="index" />

	</template>

	<template v-slot:buttons>

		<com-toggle :options="sortOptions" :value="sortValue" v-on:change="onSortChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'duration.sort' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/duration']

		},

		active: function() {

			return this.data.duration.length && !this.loading

		},

		sortOptions: function() {

			var options = []

			options.push({value: 'total', text: 'Total time'})
			options.push({value: 'avg', text: 'Avg. time'})

			return options

		},

		sortValue: function() {

			return this.$store.getters['filter/insights/players/duration/sort']

		}

	},

	methods: {

		onSortChange: function(value) {

			this.$store.commit('filter/insights/players/duration/sort', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersDuration'
			})
		
		}

	}

}

</script>

<style scoped>

</style>